import { LSCField } from '../../models/LSCFields';
import { CellStyle, GridOptions } from 'ag-grid-community';

export const MAX_JAVA_INT = 2147483647;

export const SEARCH_DEFAULTS = {
  PAGINATOR: {
    PAGE_SIZE: MAX_JAVA_INT,
    ITEMS_PER_PAGE: [10, 25, 50, 100, 250, 500, MAX_JAVA_INT],
  },
};

export const DATA_STALE_AFTER_HR = 1;
export const MAX_LOCATION_BATCH = 500;
export const MIN_BATCH_SIZE = 100;
export const MAX_PARALLEL_REQUESTS = 20;
export const MAX_RETRIES_PER_PAGE_SIZE = 3;
export const RETRY_DELAY_MS = 500;

// TODO: Ask BE to clean this up
// Dictionary of alternative FieldIds
export const ALTERNATIVE_FIELD_IDS = {
  [LSCField.businessName]: 'locationName',
  [LSCField.website]: 'websiteUrl',
  [LSCField.businessHours]: 'regularHours',
  [LSCField.additionalCategory]: 'additionalCategories',
  [LSCField.fromTheBusiness]: 'profile',
  [LSCField.additionalPhone]: 'additionalPhones',
  [LSCField.adwordsLocation]: 'adWordsLocationExtensions',
  [LSCField.openingDate]: 'openInfo.openingDate',
  [LSCField.coordinateImport]: 'importedCoordinates',
  [LSCField.coordinate]: 'verifiedCoordinates', //todo rename BLS-2470
  lastUpdated: 'editTimestamp',
  [LSCField.businessStatus]: 'openInfo.status',
  [LSCField.appointmentURL]: 'url_appointment',
  [LSCField.menuURL]: 'url_menu',
  [LSCField.orderAheadURL]: 'url_order_ahead',
  [LSCField.reservationsURL]: 'url_reservations',
};

/**
 * Introduced in BLS-660. Prone to refactoring.
 */
export const COORDINATES_COMPARISON_FIELD_ID = 'latLng';

// Address Subfields
export const ADDRESS_SUBFIELDS = [
  LSCField.addressLine1,
  LSCField.addressLine2,
  LSCField.addressLine3,
  LSCField.addressLine4,
  LSCField.addressLine5,
  LSCField.state,
  LSCField.district,
  LSCField.city,
  LSCField.country,
  LSCField.postalCode,
  LSCField.coordinateImport,
  LSCField.coordinate,
];

// Business Hours Subfields
export const BUSINESS_HOURS_SUBFIELDS = [
  LSCField.mondayHours,
  LSCField.tuesdayHours,
  LSCField.wednesdayHours,
  LSCField.thursdayHours,
  LSCField.fridayHours,
  LSCField.saturdayHours,
  LSCField.sundayHours,
];

// Differences-specific fields
export const PHONE_NUMBERS_SUBFIELDS = [
  LSCField.primaryPhone,
  LSCField.additionalPhone,
];

export const CATEGORIES_SUBFIELDS = [
  LSCField.primaryCategory,
  LSCField.additionalCategory,
];

// Differences component can show complex fields which data connection status depends on data
// connection status of several subfields
export const COMPLEX_DATA_CONNECTION_FIELDS = {
  'address': ADDRESS_SUBFIELDS,
  'categories': CATEGORIES_SUBFIELDS,
  'phoneNumbers': PHONE_NUMBERS_SUBFIELDS,
};

export const COLUMNS_VISIBLE_BY_DEFAULT = [
  LSCField.storeCode,
  LSCField.status,
  LSCField.comment,
  LSCField.businessName,
  LSCField.addressLine1,
  LSCField.city,
  LSCField.country,
  LSCField.website,
  LSCField.businessHours,
  LSCField.differences,
  'rowMenu',
];

/**
 * Fields that can be edited in BLS. Ordered! Will show in this order in Edit data in BLS popup.
 */
export const EDITABLE_FIELD_IDS = [
  LSCField.businessStatus,
  LSCField.businessName,
  LSCField.addressLine1,
  LSCField.addressLine2,
  LSCField.addressLine3,
  LSCField.addressLine4,
  LSCField.addressLine5,
  LSCField.city,
  LSCField.district,
  LSCField.state,
  LSCField.country,
  LSCField.postalCode,
  LSCField.coordinateImport,

  LSCField.primaryPhone,
  LSCField.additionalPhone,
  LSCField.adwordsLocation,
  LSCField.website,
  LSCField.primaryCategory,
  LSCField.additionalCategory,
  LSCField.fromTheBusiness,
  LSCField.labels,

  LSCField.mondayHours,
  LSCField.tuesdayHours,
  LSCField.wednesdayHours,
  LSCField.thursdayHours,
  LSCField.fridayHours,
  LSCField.saturdayHours,
  LSCField.sundayHours,
  LSCField.specialHours,
  LSCField.gxSpecialHours,
  LSCField.openingDate,

  LSCField.logoPhoto,
  LSCField.coverPhoto,
  LSCField.otherPhotos,

  LSCField.menuURL,

  LSCField.appointmentURL,
  LSCField.orderAheadURL,
  LSCField.reservationsURL,
  LSCField.socialMediaUrls,

  LSCField.customServices,

  LSCField.comment,
  LSCField.managementStatus,
];

/**
 * Fields that can be exported. Ordered! Will show in this order in Export popup.
 */
export const EXPORTABLE_FIELD_IDS = [
  LSCField.comment,
  LSCField.businessName,
  LSCField.addressLine1,
  LSCField.city,
  LSCField.country,
  LSCField.website,
  LSCField.businessStatus,
  LSCField.businessHours,

  LSCField.specialHours,
  LSCField.gxSpecialHours,
  LSCField.openingDate,

  LSCField.addressLine2,
  LSCField.addressLine3,
  LSCField.addressLine4,
  LSCField.addressLine5,
  LSCField.postalCode,
  LSCField.district,
  LSCField.state,
  LSCField.coordinateImport,
  LSCField.coordinate,

  LSCField.coverPhoto,
  LSCField.logoPhoto,
  LSCField.otherPhotos,

  LSCField.primaryPhone,
  LSCField.additionalPhone,
  LSCField.adwordsLocation,
  LSCField.primaryCategory,
  LSCField.additionalCategory,
  LSCField.fromTheBusiness,
  LSCField.labels,
  LSCField.customServices,
  LSCField.menuURL,

  LSCField.appointmentURL,
  LSCField.orderAheadURL,
  LSCField.reservationsURL,
  LSCField.socialMediaUrls,

  LSCField.existsInGMB,
  LSCField.differentInGMB,
  LSCField.myBusinessLocationUrl,
  LSCField.searchUrl,
  LSCField.mapsUrl,
  LSCField.placeId,
  LSCField.locationId,
  LSCField.gmbAccountIds,
  LSCField.gmbLocationId,

  LSCField.dataGoldmine,
  LSCField.verified, //todo rename BLS-2470
  LSCField.blackListedFields,
  LSCField.managementStatus,
];

export const REQUIRED_FIELDS = [
  LSCField.businessName,
  LSCField.addressLine1,
  LSCField.city,
  LSCField.country,
  LSCField.primaryCategory,
];

export const TRANSLATABLE_FIELDS = [
  LSCField.businessName,
  LSCField.district,
  LSCField.city,
  LSCField.state,
  LSCField.addressLine1,
  LSCField.addressLine2,
  LSCField.addressLine3,
  LSCField.addressLine4,
  LSCField.addressLine5
];

export const AUTOCOMPLETE_MARKER_ID = 'autocompleteMarker';
export const VALIDATED_MARKER_ID = 'validatedMarker';

export const DEFAULT_GRID_CELL_STYLE: CellStyle = { // 48px height total
  fontSize: '14px',
  lineHeight: '20px',
  paddingTop: '14px', // makes sure text is centered
  paddingBottom: '14px',
};

export const DEFAULT_GRID_OPTIONS: GridOptions = {
  headerHeight: 30,
  floatingFiltersHeight: 42,
  animateRows: true,
  enableCellTextSelection: true,
};

export const DEFAULT_GRID_COLUMN_DEFS = {
  cellStyle: DEFAULT_GRID_CELL_STYLE,
  // do not show the filter trigger next to floating filters
  suppressFloatingFilterButton: true,
  // do not show the filter button in the column header
  suppressHeaderFilterButton: true
};
